import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useProductWornTogether } from '@/hooks/react-query/products/use-product'
import { useTranslations } from 'next-intl'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { ProductInfoSuggest } from './module'

export const ProductSuggestCarousel = () => {
  const t = useTranslations('product_detail.title')
  const { product } = useProductDetailSafe()
  const { data: wornTogetherProducts } = useProductWornTogether(product?.id)
  if (!wornTogetherProducts || !wornTogetherProducts.length) return null

  return (
    <div
      className='mt-2.5 border-t border-t-neutral-200 pt-4 lg:mt-4'
      data-tracking-level-2={'Matchinglook'}
    >
      <h2 className='mb-2 font-sans text-sm font-bold uppercase leading-4.5 text-neutral-900 lg:text-base lg:leading-5'>
        {t('worn_together')}
      </h2>
      <Carousel
        opts={{
          align: 'start',
          duration: 50,
          slidesToScroll: 2,
          skipSnaps: true,
        }}
        className='w-full'
      >
        <CarouselContent>
          {wornTogetherProducts?.map((product) => (
            <CarouselItem
              key={product.id}
              className='basis-5/12 will-change-transform sm:basis-1/4 lg:basis-1/3'
              data-product-id={product.id}
            >
              <ProductInfoSuggest.Item product={product} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
    </div>
  )
}

const CarouselNavigation = () => {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-4 top-1/2 h-8 w-8 -translate-y-1/2 sm:-left-4 xl:-left-10'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-4 top-1/2 h-8 w-8 -translate-y-1/2 sm:-right-4 xl:-right-10'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
